import React from "react";
import {FormattedMessage} from "react-intl";

const UserTypeSelect = ({value, userTypes, onClick, disableUnselected}) => {
  return (
    <div className="w-full flex flex-col sm:flex-row gap-x-4 gap-y-2">
      {userTypes.map((item) => {
        const selected = value === item.cod_user_type;
        let activeClasses = `border-2 border-am-500 rounded-md ${selected ? "" : "border-opacity-0 hover:border-opacity-100"}`

        const disabled = disableUnselected && !selected;
        if (disabled)
          activeClasses += " opacity-30 cursor-not-allowed pointer-events-none";

        return (
          <div
            key={item.id}
            className={`flex-1 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          >
            <div
              className={`p-2 flex flex-col items-center cursor-pointer mr-2 mb-2 ${activeClasses}`}
              onClick={() => {
                if (disabled)
                  return;  // do nothing
                onClick(item.cod_user_type);
              }}
            >
              <div
                className="w-8 h-16 mb-2 bg-contain bg-center relative bg-no-repeat"
                style={{
                  backgroundImage: `url(${item.icon_name})`,
                  height: "50px",
                  width: "50px",
                }}
              />
              <p className="text-center">
                <FormattedMessage id={item.cod_user_type}/>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserTypeSelect;
